import Vue from 'vue'

import ElementUI from 'element-ui';                      // 引入element-ui
import 'element-ui/lib/theme-chalk/index.css';           // element-ui的css样式要单独引入
import locale from 'element-ui/lib/locale/lang/en'
import App from './App.vue'

// 引入路由对象
import router from './router'

import * as echarts from 'echarts';
//需要挂载到Vue原型上
Vue.prototype.$echarts = echarts

// 引入axios
import axios from './util/axiosConfig'
Vue.prototype.$axios = axios
Vue.prototype.$http = axios

import LazyLoad from './components/tools/Lazy-load'
Vue.component('Lazy-load', LazyLoad)

import TrueLabelChart from './components/Dataset/TrueLabelChart'
Vue.component('TrueLabelChart', TrueLabelChart)

import AllLabelChart from './components/Dataset/AllLabelChart'
Vue.component('AllLabelChart', AllLabelChart)

import global from "./util/global"
Vue.prototype.$global=global;

Vue.use(ElementUI,{locale});   // 这种方式引入了ElementUI中所有的组件


Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router    // 注入路由对象
})
